import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getClientTimelineStatusCongFig = () => {
    return httpClient.get(server.CLIENT_TIMELINE_STATUS_CONFIG);
};
export const getClientTimelineStatusCongFigSql = () => {
    return httpClient.get(server.CLIENT_TIMELINE_STATUS_CONFIG + "/sql");
};
export const getClientTimelineStatusByIDCongFig = (id) => {
    return httpClient.get(server.CLIENT_TIMELINE_STATUS_CONFIG + `/${id}`);
};
export const getClientTimelineStatusCongFigByModule = (module) => {
    return httpClient.get(server.CLIENT_TIMELINE_STATUS_CONFIG + `/module/${module}`);
};
export const getClientTimelineStatusCheckDuplications = (query) => {
    return httpClient.get(server.CLIENT_TIMELINE_STATUS_CONFIG + `/check-primay-duplications`, query);
};
export const createClientTimelineStatusCongFig = (data) => {
    return httpClient.post(server.CLIENT_TIMELINE_STATUS_CONFIG + `/`, data);
};
export const updateClientTimelineStatusCongFig = (id, data) => {
    return httpClient.put(server.CLIENT_TIMELINE_STATUS_CONFIG + `/${id}`, data);
};
export const deleteClientTimelineStatusCongFig = (params) => {
    return httpClient.delete(
        server.CLIENT_TIMELINE_STATUS_CONFIG,
        { params }
    )
}